import FunctionWrapper from './function/FunctionWrapper';

interface FunctionMap {
  [key: string]: (args: any) => void;
}

export type FunctionType = 'form' | 'report' | 'process';

export default class FunctionManager {
  private functionMap: FunctionMap;
  private wrapper: FunctionWrapper;

  constructor() {
    this.functionMap = {};
    this.wrapper = new FunctionWrapper();
  }

  public register(key: string, fun: (args: any) => void, type: FunctionType) {
    this.functionMap[key] = this.wrapper.wrap(fun, type);
  }

  public run(context: any) {
    let type = 'Unknow';
    if (context.form) {
      type = 'Form';
    } else if (context.process) {
      type = 'Process';
    } else if (context.report) {
      type = 'Report';
    }
    const beforeAll = this.functionMap[`BeforeAll${type}`];
    if (beforeAll) {
      beforeAll(context);
    }

    if (context.define) {
      const fn = this.load(context.define);
      if (fn) {
        fn(context);
      }
    }
  }

  private load(define: any): (args: any) => void {
    return this.functionMap[define.id]
      || this.functionMap[define.alias]
      || this.functionMap[define.componentId];
  }
}
